import React, { useContext, useEffect, useState } from 'react'
import AdminContext from '../../../StateContext/Application'
import { Form, Link } from 'react-router-dom'
import { apiurl } from '../../../../../path'

const ShowAuctions = () => {
    const data = useContext(AdminContext)
    const [Display, SetDisplay] = useState('none')
    const [Displayrender, SetDisplayRender] = useState({})
    const [Data, SetData] = useState([])
    const upload = new FormData();
    const { GetAuctionsList, EditAuction } = data
    const [showFileUpload, setShowFileUpload] = useState(false);
    const [searchTerm, setSearchTerm] = useState(''); // State for search input


    const Search = async (e) => {
        try {
            if (!e) {
                let data = await GetAuctionsList("getallauctions")
                console.log("Data", data);

                SetData(Array.isArray(data) ? data : []);
            }
            else {
                let data = await GetAuctionsList("Search", e)

                SetData(Array.isArray(data) ? data : []);
            }
        } catch (error) {
            console.error('Error in Search:', error);
        }
    }

    useEffect(() => {
        try {
            Search('')
        } catch (error) {
            console.error('Error in useEffect:', error);
        }
    }, [])

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value); // Update the search term state
        Search(value); // Trigger search with the updated term
    };

    var [formData, setFormData] = useState({
        type: 'Edit',
        Tender_Name: '',
        PO_Number: '',
        Description: '',
        GST: '',
        Tender_Picture: '',
        Tender_Opening_Date: '',
        Tender_Closing_Date: '',
        ErnestMoneyDeposit: '',
        TenderFee: '',
        Contact_Information: '',
        Tender_Supporting_Docs: '',
        Tender_Status: "",
        Remark: "",
        Cancel_Docs: ""
    });

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            let id = e.currentTarget.id
            upload.append('Tender_ID', Displayrender.Tender_ID)

            for (const key in formData) {
                upload.append(key, formData[key]);
            }

            let Auction_Picture = document.getElementById('Tender_Picture').files;
            upload.append('AuctionDocs', Auction_Picture[0]);
            let Auction_Supporting_Docs = document.getElementById('Tender_Supporting_Docs').files;
            upload.append('AuctionDocs', Auction_Supporting_Docs[0]);

            // Get the file input element
            const cancelDocsInput = document.getElementById('Cancel_Docs');

            // Check if the file input exists and if there is a file selected
            if (cancelDocsInput && cancelDocsInput.files.length > 0) {
                // If a file is selected, proceed with file upload logic
                let Cancel_Docs = cancelDocsInput.files[0];
                console.log("Cancel Docs selected:", Cancel_Docs);
                // Proceed with appending the file for upload (if applicable)
                upload.append('Cancel_Docs', Cancel_Docs);
            } else {
                console.log("No Cancel Document uploaded");
                // Proceed without the cancel document upload
            }
            let data = await EditAuction(upload)
            if (data == "Edit") {
                alert("Scheme Edited Successfully")
                window.location.reload()
            } else if (data == "Cancel") {
                alert("Scheme Cancel Successfully")
                window.location.reload()
            } else {
                alert(405)
            }
        } catch (error) {
            console.error('Error in handleSubmit:', error);
        }
    };

    const handleInputChange = (e) => {
        try {
            const { id, value } = e.target;
            // Show file upload input if "Cancel" is selected
            if (id === 'Tender_Status' && value === 'Cancel') {
                setShowFileUpload(true);
            } else if (id === 'Tender_Status') {
                setShowFileUpload(false);
            }


            // Check if the field being updated is the Tender_Name
            if (id === 'Tender_Name') {
                // Regular expression to match special characters
                const specialCharacterRegex = /[^a-zA-Z0-9 ]/g;

                // Test if the value contains any special characters
                if (specialCharacterRegex.test(value)) {
                    alert('Scheme Name cannot contain special characters');
                    return; // Do not update the state if invalid input
                }
            }
            setFormData({
                ...formData,
                [id]: value,
            });
        } catch (error) {
            console.error('Error in handleInputChange:', error);
        }
    };


    const Openscreen = () => {
        try {
            if (Display == 'none') {
                formData.Tender_Name = Displayrender.Tender_Name
                formData.PO_Number = Displayrender.PO_Number
                formData.Description = Displayrender.Description
                formData.Tender_Picture = Displayrender.Tender_Picture
                formData.Tender_Supporting_Docs = Displayrender.Tender_Supporting_Docs
                formData.GST = Displayrender.GST
                formData.Tender_Closing_Date = Displayrender.Tender_Closing_Date
                formData.Tender_Opening_Date = Displayrender.Tender_Opening_Date
                formData.ErnestMoneyDeposit = Displayrender.ErnestMoneyDeposit
                formData.TenderFee = Displayrender.TenderFee
                formData.Contact_Information = Displayrender.Contact_Information
                formData.Tender_Status = Displayrender.Tender_Status
                formData.Remark = Displayrender.Remark
                formData.Cancel_Docs = Displayrender.Cancel_Docs
                SetDisplay('grid')
            }
            else {
                setFormData({
                    
                    Remark: '',
                    Tender_Status: '',
                    Cancel_Docs: '',
                });
                setShowFileUpload(false);
                SetDisplay('none')
            }
        } catch (error) {
            console.error('Error in Openscreen:', error);
        }
    }

    return (
        <div style={{ backgroundColor: "#f6f8fc", padding: "20px" }}>
            <div style={{ display: "grid", border: "2px solid red", borderRadius: "20px", border: "none", padding: "5px", backgroundColor: 'white' }}>
                <h1>Schemes</h1>
            </div>

            {/* Search Bar */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search by Scheme Name"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    style={{ width: '50%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                />
            </div>


            {/* <div style={{ display: 'grid', justifyContent: 'center' }}>
                <div>
                    <select onChangeCapture={(e) => { SetDisplayRender(JSON.parse(e.currentTarget.value)); Openscreen() }} onChange={(e) => { SetDisplayRender(JSON.parse(e.currentTarget.value)); Openscreen() }}>
                        {
                            Data && Data.map((e) => (
                                <option value={JSON.stringify(e)} ><button className='btn btn-dark' >{e.Tender_Name}</button></option>
                            ))
                        }
                    </select>
                </div>
            </div>
            <hr></hr> */}
            <div style={{ display: 'flex', justifyContent: "center", width: '100%' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', height: '30rem', overflow: 'auto', justifyContent: 'center' }}>

                    {Data && Data?.map((auction, key) => (
                        <div key={key} className="card hovereffect" style={{ width: '15rem', margin: '1rem', height: '20rem' }}>
                            <img src={auction.Tender_Picture ? `${apiurl}/AuctionDetailsget/${auction.Tender_Picture}` : "https://www.the-sustainable-fashion-collective.com/img/http/assets.the-sustainable-fashion-collective.com/assets/the-swatch-book/2014/11/cotton.png/7c098280951a28c0f2aa4291f179ae42.png"} className="card-img-top" alt="..." style={{ height: '10rem', width: "15rem" }} />
                            <div className="card-body" style={{ display: "grid" }}>
                                <h5 style={{ textAlign: "center" }} className="card-title">{auction.Tender_Name}</h5>
                                <div style={{ display: "flex", justifyContent: "space-evenly" }}>
                                    <button href="#" onClickCapture={() => SetDisplayRender(auction)} onClick={(e) => { SetDisplayRender(auction); Openscreen() }} className="btn btn-danger mx-2 my-3" style={{ backgroundColor: "transparent", color: "red" }}>Edit</button>
                                    <button href="#" onClickCapture={() => SetDisplayRender(auction)} onClick={(e) => { SetDisplayRender(auction); Openscreen() }} className="btn btn-success mx-2 my-3" style={{ backgroundColor: "transparent", color: "green" }}>View</button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px solid #ccc',
                    borderRadius: '10px',
                    padding: '1rem',
                    display: Display,
                }}>
                    <div className="card" style={{ alignSelf: 'center', width: '40vw', display: 'grid', height: '80vh', justifyContent: 'center' }}>
                        <div className="card" style={{ alignSelf: 'center', width: '40vw', display: 'grid', height: '80vh', justifyContent: 'center', padding: '3rem', overflow: 'auto' }}>
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <img src={Displayrender.Tender_Picture ? `${apiurl}/AuctionDetailsget/${Displayrender.Tender_Picture}` : "https://www.the-sustainable-fashion-collective.com/img/http/assets.the-sustainable-fashion-collective.com/assets/the-swatch-book/2014/11/cotton.png/7c098280951a28c0f2aa4291f179ae42.png"} className="card-img-top" alt="..." style={{ height: '5rem', width: '5rem' }} />
                            </div>
                            <div className="col" style={{ display: "flex", justifyContent: "center" }}>
                                <label htmlFor="Tender_Name" className="form-label"><b>Scheme id</b> {Displayrender.Tender_ID}</label>
                            </div>
                            <Form onSubmit={(e) => handleSubmit(e)}>
                                <div className="row mb-3">
                                    <div className="col">
                                        <label htmlFor="Tender_Name" className="form-label">Scheme Name</label>
                                        <input type="text" className="form-control" value={formData.Tender_Name} onChange={(e) => handleInputChange(e)} id="Tender_Name" placeholder='Enter Scheme Name Here' />
                                    </div>
                                    <div className="col">
                                        <label htmlFor="PO_Number" className="form-label">PO Number</label>
                                        <span className="form-control" value={formData.PO_Number} onChange={(e) => handleInputChange(e)} id="PO_Number" >{formData.PO_Number}</span>
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col">
                                        <label htmlFor="Description" className="form-label">Description</label>
                                        <textarea className="form-control" value={formData.Description} onChange={(e) => handleInputChange(e)} id="Description" rows="3" placeholder='Enter Description Here'></textarea>
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">
                                        <label htmlFor="Tender_Opening_Date" className="form-label">Scheme Opening Date</label>
                                        <input type="datetime-local" value={formData.Tender_Opening_Date} className="form-control" onChange={(e) => handleInputChange(e)} id="Tender_Opening_Date" required />
                                    </div>
                                    <div className="col">
                                        <label htmlFor="Tender_Closing_Date" className="form-label">Scheme Closing Date</label>
                                        <input type="datetime-local" className="form-control" value={formData.Tender_Closing_Date} onChange={(e) => handleInputChange(e)} id="Tender_Closing_Date" required />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col">
                                        <label htmlFor="ErnestMoneyDeposit" className="form-label">Ernest Money Deposit</label>
                                        <input type="number" className="form-control" value={formData.ErnestMoneyDeposit} onChange={(e) => handleInputChange(e)} id="ErnestMoneyDeposit" placeholder='Enter Ernest Money Deposite' />
                                    </div>
                                    <div className="col">
                                        <label htmlFor="TenderFee" className="form-label">Scheme Fee</label>
                                        <input type="number" className="form-control" value={formData.TenderFee} onChange={(e) => handleInputChange(e)} id="TenderFee" placeholder='Enter Scheme Fee Here' />
                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="col">
                                        <label htmlFor="Contact_Information" className="form-label">Contact Information</label>
                                        <input type="text" pattern="\d{10}" minLength="10" maxLength="10"
                                            className="form-control"
                                            id="Contact_Information"
                                            value={formData.Contact_Information}
                                            onChange={(e) => handleInputChange(e)}
                                            onInput={(e) => {
                                                let enteredValue = e.target.value;
                                                enteredValue = enteredValue.slice(0, 10).replace(/\D/g, '');
                                                e.target.value = enteredValue;
                                            }}
                                            placeholder='Enter Contact Here'
                                        />
                                    </div>
                                    <div className="col">
                                        <label htmlFor="GST" className="form-label">GST</label>
                                        <input type="number" className="form-control" value={formData.GST} onChange={(e) => handleInputChange(e)} id="GST" placeholder='Enter GST Here' />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col">
                                        <label htmlFor="tenderType" className="form-label">Scheme Picture</label>
                                        <input type="file" className="form-control" id="Tender_Picture" />
                                    </div>
                                    <div className="col">
                                        <label htmlFor="Tender_Supporting_Docs" className="form-label">Scheme Supporting Docs </label>
                                        <textarea value={formData.Tender_Supporting_Docs} contentEditable={false}></textarea>
                                        <input type="file" className="form-control" id="Tender_Supporting_Docs" />
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col">
                                        <label htmlFor="Tender_Status" className="form-label">Scheme Status</label>
                                        <select id='Tender_Status' value={formData.Tender_Status} className='form-select' onChange={(e) => handleInputChange(e)}>
                                            <option>Select Status</option>
                                            <option value="Cancel">Cancel</option>
                                        </select>
                                    </div>
                                    <div className="col">
                                        <label htmlFor="Remark" className="form-label">Remark</label>
                                        <textarea className="form-control" value={formData.Remark} onChange={(e) => handleInputChange(e)} id="Remark" >{formData.Remark}</textarea>
                                    </div>
                                </div>

                                {/* Conditionally render file upload input */}
                                {showFileUpload && (
                                    <div className="row mb-3">
                                        <div className="col">
                                            <label htmlFor="Cancel_Docs" className="form-label">Upload Cancellation Document</label>
                                            <input type="file" className="form-control" id="Cancel_Docs" name='Cancel_
                                            Docs' />
                                        </div>
                                    </div>
                                )}
                                <div className="text-center">
                                    <button type="submit" className="btn btn-primary mx-3" style={{ backgroundColor: "rgb(10, 200, 150) ", border: "none" }}>Submit</button>
                                    <button type='button' href="#" onClick={() => { Openscreen(); }} className="btn btn-danger mx-3" style={{ backgroundColor: "#e73d26", border: "none" }}>Close</button>
                                </div>
                            </Form>
                            <hr></hr>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ShowAuctions